import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

interface ReassignByAgentParams {
  agentNamePattern: string;
  newCsrId: string;
  oldCsrId: string;
  reason?: string;
}

export function useDynamicLeadReassignment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ agentNamePattern, newCsrId, oldCsrId, reason }: ReassignByAgentParams) => {
      const { data, error } = await supabase.rpc('reassign_leads_by_agent_name', {
        _agent_name_pattern: agentNamePattern,
        _new_csr_id: newCsrId,
        _old_csr_id: oldCsrId,
        _reason: reason || 'Bulk reassignment by agent name'
      });

      if (error) throw error;
      return data?.[0] || { updated_count: 0, lead_ids: [], activities_created: 0 };
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead-activities'] });
      
      toast({
        title: 'Reassignment Complete',
        description: `Updated ${data.updated_count} leads and created ${data.activities_created} activity logs`,
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Reassignment Failed',
        description: error.message,
        variant: 'destructive',
      });
    },
  });
}
